export const MM_SECTION_MAPPING = {
  "mm-hero-section": "Top fold",
  "expert-review": "Expert rating",
  specs: "Key spec",
  variants: "Variant",
  comparison: "Comparison",
  chat: "Chatbot",
  "mm-key-specs": "Key spec",
  "mm-standout-features": "Standout feature",
  "mm-price-section": "Price",
  "mm-mileage-section": "Mileage",
  "mm-dimensions-section": "Dimension",
  "mm-colors-section": "Colour",
  "mm-emi-section": "EMI",
  "mm-gallery-section": "Gallery",
  "mm-service-cost": "Service cost",
  "mm-similar-cars": "Similar cars",
  "mm-similar-brands": "Similar brands",
  "mm-blog-section": "Blog",
  "mm-steps-section": "Steps",
  "mm-faq-section": "FAQ",
} as const;

export type MMSectionId = keyof typeof MM_SECTION_MAPPING;
export type MMSectionName = (typeof MM_SECTION_MAPPING)[MMSectionId];
